import * as React from 'react'
import type { PasswordStrength } from 'types/business'
import { getPasswordStrengthMinimumCharsInWords } from '@disco/utils/password'
import { useTranslation } from '@disco/i18n/use-translation'
type Props = {
  className?: string
  omitMinimumChars: boolean
  passwordStrength?: PasswordStrength
}

const PasswordRequirementsList = ({
  className,
  omitMinimumChars,
  passwordStrength = 'standard',
}: Props): React.ReactElement<'ul'> => {
  const { t } = useTranslation('accounts')

  return (
    <ul className={className}>
      {!omitMinimumChars && (
        <li>
          {t(
            'accounts:atLeastCharsCharacters',
            'At least {{chars}} characters',
            {
              chars: getPasswordStrengthMinimumCharsInWords(passwordStrength),
            },
          )}
        </li>
      )}
      <li>{t('accounts:atLeastOneNumber', 'At least one number')}</li>
      {passwordStrength === 'standard' ? (
        <li>
          {t(
            'accounts:optionallyUseUppercaseAndLowercaseCharactersSpecialCharactersAndNumbers',
            'Optionally use uppercase and lowercase characters, special characters and numbers.',
          )}
        </li>
      ) : (
        <>
          <li>
            {t(
              'accounts:atLeastOneUppercaseCharacter',
              'At least one uppercase character',
            )}
          </li>
          <li>
            {t(
              'accounts:atLeastOneLowercaseCharacter',
              'At least one lowercase character',
            )}
          </li>
          <li>
            {t(
              'accounts:atLeastOneSpecialCharacter',
              'At least one special character',
            )}
          </li>
        </>
      )}
    </ul>
  )
}

export default PasswordRequirementsList
